import { mixins, styled, theme, utils } from 'ui/theme';

export const Card = {
  Component: styled.div`
    background: ${theme.colors.build.lightDark2};
    display: grid;
    grid-template-rows: repeat(3, auto);
    width: 100%;

    /* Border */
    &[data-border='hairline'] {
      border: solid ${theme.borderWidths.hairline} ${theme.colors.build.lightDark1};
    }

    &[data-border='thin'] {
      border: solid ${theme.borderWidths.thin} ${theme.colors.build.lightDark1};
    }

    &[data-border='medium'] {
      border: solid ${theme.borderWidths.medium} ${theme.colors.build.lightDark1};
    }

    &[data-border='thick'] {
      border: solid ${theme.borderWidths.thick} ${theme.colors.build.lightDark1};
    }

    /* Border Radius */
    &[data-radius='rounded'] {
      border-radius: ${theme.radii.small};
    }

    /* Shadow */
    &[data-shadow='close'] {
      box-shadow: ${theme.shadows.down.close};
    }

    &[data-shadow='soft'] {
      box-shadow: ${theme.shadows.down.soft};
    }

    &[data-shadow='medium'] {
      box-shadow: ${theme.shadows.down.mid};
    }

    &[data-shadow='far'] {
      box-shadow: ${theme.shadows.down.far};
    }
  `,

  Content: styled.div`
    ${mixins.baseFont};
    background: ${theme.colors.build.lightDark2};
    color: ${theme.colors.build.darkLight};
    border-radius: inherit;

    /* Spacing */
    &[data-spacing='small'] {
      padding: ${theme.space[2]};
    }

    &[data-spacing='medium'] {
      padding: ${theme.space[4]};
    }

    &[data-spacing='large'] {
      padding: ${theme.space[6]};

      ${utils.media.max('m')`
        padding: ${theme.space[4]};
      `}
    }
  `,

  Footer: styled.footer`
    border-radius: inherit;
    overflow: hidden;

    /* Spacing */
    &[data-spacing='small'] {
      padding: 0 ${theme.space[2]} ${theme.space[2]};
    }

    &[data-spacing='medium'] {
      padding: 0 ${theme.space[4]} ${theme.space[4]};
    }

    &[data-spacing='large'] {
      padding: 0 ${theme.space[6]} ${theme.space[6]};

      ${utils.media.max('m')`
        padding: 0 ${theme.space[4]} ${theme.space[4]};
      `}
    }

    > div {
      flex-direction: row;

      ${utils.media.max('m')`
        flex-direction: column-reverse;
      `}
    }
  `,

  Header: styled.header`
    border-radius: inherit;
    max-width: 100%;
    overflow: hidden;
  `,
};
